module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".md",".mdx"],"defaultLayout":"C:\\Users\\adria\\Desktop\\Main\\DIARY-JOUR\\js-programming-studio\\java-book\\src\\templates\\blogTemplate\\blogTemplate.js","gatsbyRemarkPlugins":["gatsby-remark-autolink-headers",{"resolve":"gatsby-remark-images","options":{"maxWidth":800}}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"JavaBook","short_name":"JavaBook","start_url":"/","background_color":"#f44f18","theme_color":"#f44f18","display":"standalone","icon":"src/images/howtolearn.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"449c4eb992b40622bcd9118df0951011"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
